import React , {useEffect,useState} from "react";
//import StudentTopMenu from "./studenttopmenu";
//import StudentInfoBox from "./studentinfobox";
import { useParams } from 'react-router-dom';
import Tasks from "./sublist/tasks";
import { getIdData } from "../../../lib/studentinfo";
import Student12TopMenu from "../studentInfo/student12topmenu"
import Student911TopMenu from "../studentInfo/student911topmenu"
import PageNotes from "../../pages/common/pagenotesnew";
import GlobalStudentTask from "../../pages/common/globalstudenttask";
import GlobalCheckList from "../../pages/common/globalchecklist";
import { useAuth } from "../../../usercontext";

export default function InstructorStudentTaskList() {

  let { slug } = useParams();
  const { profile, setProfile } = useAuth();

  const [isStudent911, setisStudent911] = useState(false);
  const [isStudent12, setisStudent12] = useState(false);

  async function GetData() {
    const info = await getIdData(slug);
    if (info[0].role === "Student911") {
      setisStudent911(true);
    } else if (info[0].role === "Student12") {
      setisStudent12(true);
    }
  }
   
    useEffect(() => {
      GetData();
    }, []);


  return (
    <>
      {isStudent911 && <Student911TopMenu slug={slug} activeMenu={"Agenda"} />}
      {isStudent12 && <Student12TopMenu slug={slug} activeMenu={"Agenda"} />}
      <PageNotes
        type={"Instructor"}
        pageName={"Agenda"}
        studentId={slug}
        instructorId={profile.id}
      />
       <GlobalStudentTask studentId={slug} type={226} isStudent={false} />
       {isStudent12 && <GlobalCheckList slug={slug} isStudent={false} />}
       
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-0">
          <Tasks slug={slug} />
        </div>
      </div>
    </>
  );
}
